import styled from '@emotion/styled';
import theme from '../../../theme';
import {
  color,
  typography,
  space,
  border,
  flexbox,
  layout,
  variant,
  grid,
  position,
  shadow,
  ColorProps,
  TypographyProps,
  SpaceProps,
  BorderProps,
  FlexboxProps,
  LayoutProps,
  GridProps,
  PositionProps,
  ShadowProps
} from 'styled-system';

export interface BoxProps extends
  ColorProps,
  TypographyProps,
  SpaceProps,
  BorderProps,
  FlexboxProps,
  LayoutProps,
  GridProps,
  PositionProps,
  ShadowProps
{
  fontScale?: keyof typeof theme.fontScales,
  color?: any,
}

const Box = styled.div<BoxProps>(
  color,
  typography,
  space,
  border,
  flexbox,
  layout,
  grid,
  position,
  shadow,
  variant({
    prop: 'fontScale',
    variants: { ...theme.fontScales },
  }),
);

export default Box;
